///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.report_type = abcsetup.report_type || {};
abcsetup.report_type.edit = abcsetup.report_type.edit || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.report_type.edit = {
    init: function() {
        var report_type = JSON.parse(String($('form.report_type #report_type_object').text()));

        abcsetup.form_manager.form = $('form.report_type');

        for (var i in report_type) {
            abcsetup.form_manager._setFieldValue(i,report_type[i]);
        };
    },
}